/**
 * Конфигурация текстов для различных типов печати
 * Ключи соответствуют типам групп печати в store (ticket, invoice, fiscal)
 */
export const PRINT_LABELS = {
    ticket: {
        progress: 'Подождите, идёт печать фишек...',
        success: `Все фишки успешно распечатаны`,
        error: 'Ошибка печати',
        errorText: (errors, count) =>
            `Не удалось распечатать фишки (0/${count}):\n\n${errors}`,
        partialText: (success, total, errors) =>
            `Успешно: ${success}/${total} фишек\nОшибок: ${
                total - success
            }\n\n${errors}`,
        aggregateText: (successful, total, failed) =>
            `Успешно: ${successful}/${total} фишек\nОшибок: ${failed}`,
    },
    invoice: {
        progress: 'Подождите, идёт печать накладных...',
        success: `Все накладные успешно распечатаны`,
        error: 'Ошибка печати',
        errorText: (errors, count) =>
            `Не удалось распечатать накладные (0/${count}):\n\n${errors}`,
        partialText: (success, total, errors) =>
            `Успешно: ${success}/${total} накладных\nОшибок: ${
                total - success
            }\n\n${errors}`,
        aggregateText: (successful, total, failed) =>
            `Успешно: ${successful}/${total} накладных\nОшибок: ${failed}`,
    },
    fiscal: {
        progress: 'Подождите, идёт печать фискального чека...',
        success: orderNumber =>
            `Фискальный чек по заказу ${orderNumber} успешно напечатан`,
        error: 'Ошибка печати фискального чека',
        errorText: errors =>
            `Не удалось напечатать фискальный чек по заказу ${
                errors ? `:\n${errors}` : ''
            }`,
        aggregateText: (successful, total, failed) =>
            `Успешно: ${successful}/${total}\nОшибок: ${failed}`,
    },
    thermo: {
        progress: 'Подождите, идет печать термоэтикеток...',
        success: `Термоэтикетки успешно распечатаны`,
        error: 'Печать завершена с ошибками:',
        errorText: (errors, total) =>
            `Напечатано: 0/${total} термоэтикеток${
                errors ? `\n\n${errors}` : ''
            }`,
        partialText: (success, total) =>
            `Напечатано: ${success}/${total} термоэтикеток`,
        aggregateText: (successful, total, failed) =>
            `Напечатано: ${successful}/${total} термоэтикеток\nОшибок: ${failed}`,
    },
}

/**
 * Получить конфигурацию для типа печати
 * @param {string} type - тип печати (ticket, invoice, fiscal)
 * @returns {object} конфигурация типа печати
 */
export const getPrintLabels = type => PRINT_LABELS[type]
